import { render } from "./AppAnswer.vue?vue&type=template&id=bf7a59e6"
import script from "./AppAnswer.vue?vue&type=script&lang=js"
export * from "./AppAnswer.vue?vue&type=script&lang=js"

import "./AppAnswer.vue?vue&type=style&index=0&id=bf7a59e6&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__